import React, { Component } from 'react'
import { Row, Modal, Spin, message } from 'antd'
import { observer } from "mobx-react"
import { Route } from "react-router-dom"
import styled from 'styled-components'
import Store from "app/stores/arrayPgt/haplotypeReport"
import { CSVToArray } from "app/vendor/util"
import downloadIcon from "app/styles/images/sp/download.svg"
import BaseCollapse from "app/components/normal/BaseCollapse"
import HaplotypeCard from "app/components/normal/HaplotypeCard"
import SampleInfo from './containers/SampleInfo'
import SampleResult from "./containers/SampleResult"
import ReportDetail from './containers/ReportDetail'

const IframeWrapper = styled.div`
  height: 630px;
`

@observer
class HaplotypeResult extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      exportModalShowed: false
    }
  }

  componentDidMount() {
    this.initResultData()
  }

  initResultData = () => {
    let { getResultData } = this.store
    const { match: { params: { id, resultType, path } } } = this.props
    getResultData(id, resultType, path)
      .then(res => {
        const pathArr = location.pathname.split('/')
        const fileId = pathArr.slice(-1)[0]
        if (pathArr.slice(-2)[0] === 'detail') {
          this.initDetailData(id, fileId)
        }
      })
  }

  initDetailData = (reportId, fileId, resultType, path) => {
    const { getDetailData, getPgtaDetailData, detailData: { inforStats } } = this.store
    const index = inforStats && inforStats.findIndex(info => info.fileId === fileId)
    this.setState({
      dataIndex: index
    })
    getDetailData(reportId, resultType, path)
      .then(res => {
        getPgtaDetailData(reportId, fileId)
      })
  }

  reloadPageData = () => {
    this.initResultData()
  }

  onOpenCopyDetail = (fileId) => {
    const { getPgtaDetailData, resultData: { inforStats } } = this.store
    let { history, match: { params: { id } } } = this.props

    const index = inforStats && inforStats.findIndex(info => info.fileId === fileId)

    this.setState({
      dataIndex: index
    })

    getPgtaDetailData(id, fileId)
    history.push(`/jab/array-pgt/${id}/preview/detail/${fileId}`)
  }

  dataSwitch = (index, record) => {
    let { history, match: { params: { id } } } = this.props
    const { getPgtaDetailData } = this.store

    this.setState({
      dataIndex: index,
    })

    history.replace(`/jab/array-pgt/${id}/preview/detail/${record.fileId}`)
    getPgtaDetailData(id, record.fileId)
  }

  downloadReport = () => {
    let { match: { params: { id } } } = this.props
    const { downloadReport } = this.store
    downloadReport(id)
      .then(res => {
        const exportDataUrl = res.url

        this.setState({
          exportModalShowed: false,
        })

        if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", exportDataUrl)
        a.setAttribute("id", "export-a-tag")
        a.setAttribute("style", "display:none;")
        // 防止反复添加
        if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
      }, err => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
      })
  }

  render() {
    const { pgtaDetailData, resultData } = this.store
    let { history, match: { params: { id } } } = this.props
    const { dataIndex } = this.state
    return (
      <div className="haplotype-wrapper">
        <HaplotypeCard title='样本信息'>
          <SampleInfo
            store={this.store}
          />
        </HaplotypeCard>
        <HaplotypeCard title='样本结果'>
          <SampleResult
            store={this.store}
            onOpenCopyDetail={this.onOpenCopyDetail}
          />
        </HaplotypeCard>
        <HaplotypeCard title='家系结果'>
          {resultData.results && resultData.results.map((dir, index) => {
            return (
              <HaplotypeCard
                key={index}
                dir={dir}
                cb={this.reloadPageData}
                title={dir.name}
                path={dir.fullPath}
                store={this.store}
                reportId={id}
              >
                {(dir.type === 'img' && dir.name.includes('png')) && (
                  <img
                    className='result-image'
                    src={dir.value}
                    alt=''
                  />
                )}
                {dir.type === 'txt' && (
                  <table className='haplotype-result-table'>
                    <tbody>
                      {CSVToArray(dir.value, '\t').slice(0, -1).map((tr, index) => {
                        const tdData = Object.keys(tr)
                        return (
                          <tr key={index}>
                            {tdData.map((td, idx) => {
                              return (
                                <td key={idx}>
                                  {tr[td]}
                                </td>
                              )
                            })}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                )}
                {dir.type === 'xls' && (
                  <IframeWrapper>
                    <iframe
                      src={dir.fullPath}
                      frameBorder="0"
                      width='100%'
                      height='100%'
                    >
                    </iframe>
                  </IframeWrapper>
                )}
              </HaplotypeCard>
            )
          })}
        </HaplotypeCard>
        <BaseCollapse title='运行信息'>
          <Row type="flex" justify="start">
            <label className="run-label">taskId：</label>
            <p>{resultData.taskId}</p>
          </Row>
          <Row type="flex" justify="start">
            <label className="run-label">reportId：</label>
            <p>{resultData.reportId}</p>
          </Row>
          <Row type="flex" justify="start">
            <label className="run-label">runtime message：</label>
            <pre>{resultData.runtime ? resultData.runtime.message : ''}</pre>
          </Row>
        </BaseCollapse>
        <a
          title="下载报告"
          className="haplotype-download"
          onClick={this.downloadReport}
        >
          <img src={downloadIcon} alt="下载" />
        </a>
        {/* 拷贝数报告详情modal */}
        <Route
          path={`/jab/array-pgt/:id/preview/detail/:fileId`}
          render={() => {
            return (
              <Modal
                title="拷贝数报告详情"
                footer={0}
                width={1172}
                maskClosable={false}
                visible={true}
                onCancel={history.goBack}
                className="detail-modal"
              >
                <ReportDetail
                  index={dataIndex}
                  pgtaDetailData={pgtaDetailData}
                  reportList={resultData.inforStats}
                  dataSwitch={this.dataSwitch}
                  store={this.store}
                />
              </Modal>
            )
          }}
        />
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }
}

export default HaplotypeResult


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/haplotypeResult/index.js